// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'

import './assets/main.css'
import axios from 'axios'
import common from '@/utils/common.js'
import store from './store'
// axios.defaults.baseURL = '/ip'

import {
  Button,
  Image,
  Radio,
  Pagination,
  Message,
  Loading,
  Carousel,
  Input,
  CarouselItem,
  Dialog
} from 'element-ui'
import { getRequest, postRequest, postRequestVisit } from './utils/utils'

import Head from '@/components/head'

import Bottom from '@/components/bottom'
import { getUser } from '@/utils/auth'
Vue.config.productionTip = false
axios.defaults.baseURL = '/api'
Vue.use(Button)
Vue.use(Image)
Vue.use(Dialog)
Vue.use(Pagination)
Vue.use(Input)

Vue.use(Radio)
Vue.use(Carousel)
Vue.use(CarouselItem)
// Vue.component(Message.name, Message)
Vue.prototype.getRequest = getRequest
Vue.prototype.postRequest = postRequest
Vue.prototype.postRequestVisit = postRequestVisit

Vue.component('Head', Head)

Vue.component('Bottom', Bottom)
// import Common from '@/components/common'
// Vue.prototype.Common = Common;

Vue.prototype.$message = Message
Vue.prototype.$loading = Loading

/* 路由发生变化修改页面title */

router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    document.title = to.meta.title
  }

  if (to.path.indexOf('/black') != -1 || to.path.indexOf('/company') != -1) {
    next()
  } else {
    if (document.body.clientWidth < 600) {
      if (to.path == '/mobile') {
        next()
      } else {
        if (to.path.indexOf('/video') == 0) {
          const ary = to.path.split('/')
          next({
            path: '/mobile',
            query: { videoId: ary.pop(), courseId: ary.pop() }
          })
        } else {
          next({ path: '/mobile' })
        }
      }
    } else {
      if (common.userBase != null) {
        postRequestVisit('Api/v1/Log/VisitLog', {
          productIds: '10',
          sourceType: 'PC',
          moduleName: to.name,
          pageUrl: 'https://sz.bjadks.com' + to.path,
          previousPageUrl: 'https://sz.bjadks.com' + from.path,
          userId: common.userBase.UserId,
          userName: common.userBase.UserName,
          customerCode: common.userBase.ComCode,
          customerName: common.userBase.ComName,
          customerId: common.userBase.ComId,
          actId: 0
        })
        next()
      } else {
        var token = common.getCookie('utoken')
        if (token != '') {
          var userInfor = getRequest('api/v1/login', {
            token: token
          }).then(data => {
            if (data.IsSuccess) {
              common.userBase = data.Data
              store.dispatch('user/login', data.Data)
              postRequestVisit('Api/v1/Log/VisitLog', {
                productIds: '10',
                sourceType: 'PC',
                moduleName: to.name,
                pageUrl: 'https://sz.bjadks.com' + to.path,
                previousPageUrl: 'https://sz.bjadks.com' + from.path,
                userId: common.userBase.UserId,
                userName: common.userBase.UserName,
                customerCode: common.userBase.ComCode,
                customerName: common.userBase.ComName,
                customerId: common.userBase.ComId,
                actId: 0
              })
              next()
            } else {
              postRequestVisit('Api/v1/Log/VisitLog', {
                productIds: '10',
                sourceType: 'PC',
                moduleName: to.name,
                pageUrl: 'https://sz.bjadks.com' + to.path,
                previousPageUrl: 'https://sz.bjadks.com' + from.path,
                userId: getUser(),
                userName: '游客',
                customerCode: '',
                customerName: '',
                customerId: 0,
                actId: 0
              })
              next()
            }
          })
        } else {
          postRequestVisit('Api/v1/Log/VisitLog', {
            productIds: '10',
            sourceType: 'PC',
            moduleName: to.name,
            pageUrl: 'https://sz.bjadks.com' + to.path,
            previousPageUrl: 'https://sz.bjadks.com' + from.path,
            userId: getUser(),
            userName: '游客',
            customerCode: '',
            customerName: '',
            customerId: 0,
            actId: 0
          })
          next()
        }
      }
    }
  }
})
/* eslint-disable no-new */
// var vue = new Vue({
//   el: '#app',
//   router,

//   components: { App },
//   template: '<App/>'
// })
var vue = new Vue({
  el: '#app',
  router,
  store,
  render: h => h(App)
})
export default vue



// WEBPACK FOOTER //
// ./src/main.js